<template>
	<o-section
		class="aside-profile__comments"
		:title="`${'Commentaire'.pluralize(setup.orderedComments.length, false)} (${setup.orderedComments.length})`">
		<em>
			<small
				v-if="setup.self.isClient()"
				class="text--grey">
				Ce commentaire vous est privé, votre agence d'interim ne pourra pas le voir
			</small>
		</em>

		<o-textarea
			ref="commentInput"
			v-model="setup.comment"
			label="Ajouter un commentaire"
			@focus="setup.isFocused = true"
			@blur="setup.isFocused = false"
			@submit="setup.addCommentAsync()"/>
		<div
			v-if="setup.isFocused || setup.comment"
			class="flex jc-fe g-xs">
			<o-button
				nude
				color="danger"
				size="xs"
				@click="setup.resetCommentInput()">
				Annuler
			</o-button>
			<o-button
				ref="sendButton"
				outline
				size="xs"
				:color="setup.comment ? 'info' : 'default'"
				:disabled="setup.comment ? false : true"
				:loading="setup.isSendingComment"
				@click="setup.addCommentAsync()">
				Enregistrer
			</o-button>
		</div>

		<o-alert
			v-if="!setup.orderedComments.length && setup.self.isAgency()"
			color="info"
			class="mt-xs">
			Laissez un commentaire sous ce profil pour votre équipe ou vos clients
		</o-alert>
		<temp-worker-comment
			v-for="orderedComment in setup.orderedComments"
			:key="orderedComment.id"
			:comment="orderedComment"
			@delete-comment="setup.deleteCommentAsync($event)"/>
	</o-section>
</template>

<script setup lang="ts">
import TempWorkerComment from './TempWorkerComment.vue';
import TempWorkerCommentListSetupService from '@/setup/temp-worker/TempWorkerCommentListSetupService';
const props = defineProps(TempWorkerCommentListSetupService.props);
const setup = new TempWorkerCommentListSetupService(props);
</script>
